var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaching-center-content"},[_c('gat-head',{staticClass:"Application-head"}),_c('div',{staticClass:"QRCode-wrap"},[_c('img',{staticClass:"code",attrs:{"src":_vm.QRCode,"alt":""}}),_c('p',{staticClass:"label"},[_vm._v("请扫描安装APP学习软件")]),_c('p',{staticClass:"label"},[_vm._v("开始学习哦")])]),_c('gat-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }